import { useLocation } from 'react-router-dom';
import { useAppStoreApi } from './appStore';

// Owned by the tab's store; closing the tab releases these values as well.
const tabStorage = new WeakMap();

export default function useModuleStorage() {
    const store = useAppStoreApi();
    const { pathname } = useLocation();
    // Other route families retain their existing behavior during migration.
    const usesTabMemory = /^\/claim(?:\/|$)/i.test(pathname) || ['/masters', '/loyalty', '/approval', '/approvalhierarchy', '/adjustment', '/adjustments', '/claim-submission', '/contract', '/reports', '/scheme'].some((prefix) => (
        pathname === prefix || pathname.startsWith(`${prefix}/`)
    ));
    const usesDocumentTabMemory = /^\/main\/(?:upload-document|posted-filter)(?:\/|$)/.test(pathname);
    if (!usesTabMemory && !usesDocumentTabMemory) {
        return sessionStorage;
    }
    if (!tabStorage.has(store)) {
        const values = new Map();
        tabStorage.set(store, {
            getItem: (key) => values.get(key) ?? null,
            setItem: (key, value) => { values.set(key, String(value)); },
            removeItem: (key) => { values.delete(key); },
        });
    }
    return tabStorage.get(store);
}
